import styled, { keyframes } from 'styled-components';
import {
  CampaignFileIconProps,
  CampaignFileProgressProps,
  CampaignUploadCardProps,
} from 'models/campaign-mkt';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const UploadCard = styled.div<CampaignUploadCardProps>`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 74px;
  border: 1px solid ${({ $error }) => ($error ? '#d20003' : '#d7dce3')};
  border-radius: 17px;
  background: #f7f8fa;
`;

export const HiddenInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
`;

export const UploadLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
  flex: 1;
  min-height: 72px;
  margin: 0;
  padding: 8px 64px 8px 8px;
  cursor: pointer;

  @media (max-width: 600px) {
    gap: 12px;
    padding-left: 16px;
  }
`;

export const FileIcon = styled.img<CampaignFileIconProps>`
  width: ${({ $selected }) => ($selected ? '18px' : '40px')};
  height: ${({ $selected }) => ($selected ? '18px' : '40px')};
  flex: 0 0 40px;
  object-fit: contain;
`;

export const UploadContent = styled.span`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
  color: #232528;
  font-family: 'Roboto Flex', sans-serif;
  font-size: 12px;
  line-height: 16px;

  strong {
    color: #33373c;
    font-size: 14px;
    line-height: 18px;
    font-weight: 700;
  }

  > span {
    color: #6a6f77;
    font-size: 12px;
    font-weight: 500;
  }

  @media (max-width: 600px) {
    strong {
      font-size: 14px;
    }
  }
`;

export const FileDetails = styled.span`
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 10px;
`;

export const FileName = styled.span`
  min-width: 0;
  padding-right: 2px;
  overflow: hidden;
  color: #6a6f77;
  font-style: italic;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FileProgress = styled.span<CampaignFileProgressProps>`
  flex: 0 0 auto;
  color: ${({ $complete }) => ($complete ? '#2f6b25' : '#0c50d3')};
  font-style: normal;
`;

export const ProgressSpinner = styled.span`
  width: 10px;
  height: 10px;
  flex: 0 0 auto;
  border: 1px solid #aeb9c8;
  border-top-color: #0c50d3;
  border-radius: 50%;
  animation: ${spin} 700ms linear infinite;
`;

export const RemoveButton = styled.button`
  position: absolute;
  top: 50%;
  right: 22px;
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  border: 0;
  padding: 0;
  background: transparent;
  transform: translateY(-50%);
  cursor: pointer;

  img {
    width: 20px;
    height: 20px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
